import { ApplicationBundleDto } from '@tallo/investor/applications';
import { IntelligentEscalationDto } from '@tallo/investor/intelligent-escalations';
import { AccessRequestToAnswerDto, PropertyInquiryDto } from '@tallo/investor/property';
import { ShowingDto } from '@tallo/investor/showing';

export enum ActionNeededType {
  IntelligentEscalation = 'IntelligentEscalation',
  ShowingRequest = 'ShowingRequest',
  Application = 'Application',
  AccessRequest = 'AccessRequest',
  WantsToApply = 'WantsToApply',
}

export interface IntelligentEscalationItem {
  type: ActionNeededType.IntelligentEscalation;
  item: IntelligentEscalationDto;
}

export interface ShowingItem {
  type: ActionNeededType.ShowingRequest;
  item: ShowingDto;
}

export interface ApplicationItem {
  type: ActionNeededType.Application;
  item: ApplicationBundleDto;
}

export interface AccessRequestItem {
  type: ActionNeededType.AccessRequest;
  item: AccessRequestToAnswerDto;
}

/** A renter waiting for an answer to their ask to apply, as Home's Wants to apply tab lists them */
export interface WantsToApplyItem {
  type: ActionNeededType.WantsToApply;
  item: PropertyInquiryDto;
}

export type ActionNeeded =
  | IntelligentEscalationItem
  | ShowingItem
  | ApplicationItem
  | AccessRequestItem
  | WantsToApplyItem;
